/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Recommended_Change_And_RerateInputs */

const en_orders_recommended_change_and_rerate = /** @type {(inputs: Orders_Recommended_Change_And_RerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recommended: change carrier and auto-rerate now.`)
};

const es_orders_recommended_change_and_rerate = /** @type {(inputs: Orders_Recommended_Change_And_RerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recomendado: cambia el transportista y recalcula ahora.`)
};

/**
* | output |
* | --- |
* | "Recommended: change carrier and auto-rerate now." |
*
* @param {Orders_Recommended_Change_And_RerateInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_recommended_change_and_rerate = /** @type {((inputs?: Orders_Recommended_Change_And_RerateInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Recommended_Change_And_RerateInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_recommended_change_and_rerate(inputs)
	return es_orders_recommended_change_and_rerate(inputs)
});